<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-age-consent"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                <div class="modal-base-head">
                    <div id="age_header" class="modal-head-txt theme-txt">{{lbl.age_consent.title}}</div>
                </div>
                <div class="modal-base-body">
                    <div v-html="lbl.age_consent.msg"></div>
                    <div v-html="lbl.age_consent.label"></div>
                    <BirthDateInput
                        :errorInfo="errorInfo[0]"
                        :inputLbl="lbl.age_consent.birthdate"
                        :isShowError="true"
                        v-model="birthdate"
                        @onDateChange="onDateChange($event)" />
                </div>
                <div class="modal-base-footer">
                    <div id="accept_age_modal">
                        <div class="err-age" v-if="errorText">{{lbl.age_consent.error_age}}</div>
                        <div class="btn-wrapper"
                             @click="clickAcceptAge()" v-if="isAcceptAge">
                            <div class="btn-txt">
                                {{lbl.age_consent.btn}}
                            </div>
                        </div>
                        <div class="btn-wrapper btn-disable" v-else>
                            <div class="btn-txt">
                                {{lbl.age_consent.btn}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
//hepler
import Locale from '@/helper/locale/locale.js';
import Util from "@/helper/Utility.js";
import FormHelper from '@/helper/FormHelper.js';
// input components
import BirthDateInput from '@/components/Input/BirthDateInput.vue';
export default {
    name: "AgeConsentModal",
    components: {
        BirthDateInput
    },
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function () {
        return {
            title: '',
            tag: '',
            btnAcceptage: '',
            busModal: null,
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),

            busPDPA: new Vue(),

            errorInfo: [],
            isSubmitted: false,
            birthdate: null,
            birthdateTimestamp: "",
            isAcceptAge: null,
            errorText: false
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;

        this.errorInfo = FormHelper.genErrorInfo(1);
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        clickAcceptAge: function () {
            if(this.isAcceptAge){
                this.hide();
                this.controller.sendCallbackAcceptAge({ tag: this.tag }, true);
            }
        },
        //control
        show: function(config) {
            this.title = config.title;
            this.btnAcceptAge = config.btnAcceptAge;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnAcceptAge)) {
                this.btnAcceptAge = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        onDateChange: function (selectedBirthDate) {
            if (!selectedBirthDate) return;

            this.birthdate = selectedBirthDate.datetime;
            this.validateAge(this.birthdate);
        },
        validateAge: function (selectedBirthDate) {
            //check age for consent
            var currentDate = new Date();
            var difference = currentDate - selectedBirthDate;
            var age = Math.floor(difference/31557600000);
            if (selectedBirthDate != null) {
                this.errorText = true;
                if (age >= 20) {
                    this.isAcceptAge = true;
                    this.errorText = false;
                } else {
                    this.isAcceptAge = false;
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
    .modal-base-head {
        #age_header {
            padding-bottom: 20px;
        }
    }
    .modal-base-body {
        text-align: center;
        // font-size: 26px;
    }
    .modal-base-footer {
        .err-age {
            color: $red_err;
            font-size: 20px;
            text-align: center;
        }
    }
</style>
<style lang="scss">
@import "@/style/modal.scss";
    .modal-age-consent {
        @extend %modal-base;

        .modal-dialog {
            height: 90vh;
            max-height: 90vh;
        }
    }
    .wrap-input {
        margin-top: 0;
        .wrap-row-ddl {
            flex-wrap: nowrap;
            justify-content: center;
            .ddl-wrapper .ddl-input .btn-ddl-input {
                padding-left: 10px;
            }
        }
    }
</style>
